var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',_vm._b({attrs:{"variant":_vm.galaxyKwdToBootstrap,"show":_vm.showP}},'b-alert',_vm.$props,false),[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.message)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }